import styled from "styled-components";
import { setPosition } from "../variables/utils";

export const AppWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  opacity: 0;
  &.active {
    opacity: 1;
  }
`;

export const CanvasWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const SceneWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  min-height: 100vh;
  height: auto;
  overflow: hidden;
`;

export const ObserverWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
`;

export const Scene = styled.div`
  width: 100%;
  height: auto;
  canvas {
    width: 100%;
    height: 100%;
    display: block;
  }
  .label-root,
  .label-inner {
    will-change: transform;
    transform: translateZ(0);
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
`;

export const Image = styled.img`
  width: 100%;
  max-width: 100%;
  display: block;
`;
